import React from 'react';
import { PapiDeviation, RelatedBlock } from '@wix/da-papi-types';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import SidebarBlockWrapper from '../../../_partials/SidebarBlockWrapper';
import DeviationDuperbrowseContext from '../../../../Duperbrowse/DeviationDuperbrowseContext';
import { getDeviationResourceType } from '../../../../DeviationViews/_helpers';
import OriginalsShopCard from '../../../../ShopCard/OriginalsShopCard';
import { useMeasureElementCookie } from '@wix/da-hooks/pkg/useMeasureElement/useMeasureElementCookie';
import { MeasuredCookieType } from '@wix/da-hooks/pkg/useMeasureElement/redux/types';

import s from './MoreOriginals.scss';

interface Props {
  block: RelatedBlock;
  deviation: PapiDeviation;
  className?: string;
}

const MAX_ITEMS = 2;

const MoreOriginals: React.FC<Props> = ({
  block,
  deviation: parentDeviation,
  className,
}) => {
  const custom_exclusives = useFlag('custom_exclusives');
  const deviations = block.deviations?.slice(0, MAX_ITEMS);

  const { ref, dimensions: measuredContainer } = useMeasureElementCookie(
    MeasuredCookieType.DEVIATION_SIDEBAR,
    {
      cookieDim: 'width',
    }
  );

  if (!custom_exclusives || !deviations || deviations.length === 0) {
    return null;
  }

  return (
    <SidebarBlockWrapper
      deviation={parentDeviation}
      block={block}
      className={className}
    >
      <DeviationDuperbrowseContext
        streamId={`sidebar-more-originals-${block.contentType}`}
        deviations={deviations}
        parent={{
          typeId: getDeviationResourceType(parentDeviation),
          itemId: parentDeviation.deviationId,
        }}
      >
        <div ref={ref} className={s['root']}>
          {deviations.map(deviation => (
            <OriginalsShopCard
              key={deviation.deviationId}
              deviation={deviation}
              width={measuredContainer.width}
              withAuthorDetails
            />
          ))}
        </div>
      </DeviationDuperbrowseContext>
    </SidebarBlockWrapper>
  );
};
MoreOriginals.displayName = 'MoreOriginals';

export default MoreOriginals;
